export const RUNTIME_001 = 'RUNTIME-001';
export const RUNTIME_002 = 'RUNTIME-002';
export const RUNTIME_003 = 'RUNTIME-003';
export const RUNTIME_004 = 'RUNTIME-004';
export const RUNTIME_005 = 'RUNTIME-005';
export const RUNTIME_006 = 'RUNTIME-006';
export const RUNTIME_007 = 'RUNTIME-007';
export const RUNTIME_008 = 'RUNTIME-008';
export const RUNTIME_009 = 'RUNTIME-009';
export const RUNTIME_010 = 'RUNTIME-010';
export const RUNTIME_011 = 'RUNTIME-011';
export const RUNTIME_012 = 'RUNTIME-012';
export const RUNTIME_013 = 'RUNTIME-013';
export const RUNTIME_014 = 'RUNTIME-014';
export const RUNTIME_015 = 'RUNTIME-015';

export const TYPE_001 = 'TYPE-001';
export const BUILD_001 = 'BUILD-001';
export const BUILD_002 = 'BUILD-002';
